<template>
  <el-container class="home_container">
    <!-- ++++++++++++++++++++++++++++++头部++++++++++++++++++++++++++++++ -->
    <el-header class="home_header">
      <h2 style="color: #fff;margin-left: 20px;">数据中心</h2>

      <div class="powerOff">
        <i class="el-icon-switch-button"></i>
        <el-button type="info" @click.native="logout">退出</el-button>
      </div>
    </el-header>

    <el-container>
      <!-- ++++++++++++++++++++++++++++++侧边栏++++++++++++++++++++++++++++++ -->
      <el-aside :width="isCollapse ? '64px' : '200px'">

        <!-- ++++++++++缩放按钮++++++++++ -->
        <button class="scaleButton" @click="collapseMenu">| | |</button>
        <!-- ++++++++++导航菜单栏++++++++++ -->
        <el-menu :collapse-transition='false' background-color="#333744" text-color="#ffffffA6" active-text-color="#ffffff" router width="200px" :default-active="currentActive" :collapse="isCollapse">         
          <template v-for="item in menuItems">  
            <template v-if="item.subs">
                <el-submenu :index="item.index" :key="item.index">
                  <template #title>
                    <i :class="item.icon" />
                    <span>{{ item.title }}</span>
                  </template>

                  <el-menu-item
                    v-for="subItem in item.subs"
                    :key="subItem.index"
                    :index="subItem.index"
                  >
                    {{ subItem.title }}
                  </el-menu-item>
                </el-submenu>
            </template>

            <template v-else>
              <el-menu-item :index="item.index" :key="item.index">
                <i :class="item.icon"></i>
                <template #title>{{ item.title }}</template>
              </el-menu-item>
            </template>
            
          </template>
        </el-menu>
      </el-aside>
      <!-- ++++++++++++++++++++++++++++++主体++++++++++++++++++++++++++++++ -->
      <el-container>

        <!-- ++++++++++++++++++++++++++++++页面标签++++++++++++++++++++++++++++++ -->
        <el-header class="navigation_header">
          <el-tag v-for="(tag,index) in tagList" :key="index" closable :type="isActive(tag.path)"
            @close="delTag(index)">
            <router-link :to="tag.path">{{tag.title}}</router-link>
          </el-tag>
        </el-header>

        <!-- ++++++++++++++++++++++++++++++子页面++++++++++++++++++++++++++++++ -->
        <el-main>
          <!-- keep-alive的功能相当于对画面进行缓存 防止画面切换造成每个画面进行重新加载 -->
          <keep-alive :include="nameList">
            <router-view></router-view>
          </keep-alive>
        </el-main>

      </el-container>

    </el-container>
  </el-container>
</template>

<script>
  import {
    computed
  } from "vue";
  export default {
    name: "",
    components: {

    },
    data() {
      return {
        // 侧边栏折叠
        isCollapse: false,
        // 菜单栏当前选中页面
        currentActive: "",
        // 菜单栏内容
        menuItems: [{
            icon: "el-icon-user-solid",
            index: "1",
            title: "数据分列",
            subs: [{
                index: "/students",
                title: "设备列表"
              },
              {
                index: "/PLCdata",
                title: "PLC数据"
              },
              {
                index: "/permissions",
                title: "权限列表"
              },
              {
                index: "/roles",
                title: "角色列表"
              },
              {
                index: "/log",
                title: "操作日志"
              }
            ],
          },
          {
            icon: "el-icon-user-solid",
            index: "/login",
            title: "登录"
          },
        ],

        // 页面标签清单
        tagList: [],
        // 页面缓存清单
        nameList: [],
      };
    },

    created() {
      // 获取当前路由的路径、标题、名字 生成标签
      this.setTags(this.$route.path, this.$route.meta.title, this.$route.name)
      // 菜单栏展示当前页面对应的项
      this.currentActive = this.$route.path
    },

    mounted() {
    },

    beforeRouteUpdate(to, from, next) {
      // 跳转页面前添加标签、改变菜单栏选中的项
      this.setTags(to.fullPath, to.meta.title, to.name)
      this.currentActive = to.fullPath
      next()
    },

    methods: {
      //折叠菜单栏按钮
      collapseMenu() {
        this.isCollapse = !this.isCollapse
      },
      // 通过路由确定标签内容
      setTags(path, title, name) {
        // 判断标签是否存在  循环判断
        const isExist = this.tagList.some((item) => {
          //return布尔量
          return item.path === path;
        });

        if (!isExist) {
          var temp = {
            path: path,
            title: title,
            name: name
          }
          // 判断标签数量是否大于8个 多的删去最开始的
          if (this.tagList.length >= 8) {
            this.tagList.splice(0, 1)
          }
          this.tagList.push(temp)
        }

        // 导出页面缓存清单
        this.nameList = computed(() =>
          this.tagList.map((item) => item.name)
        );
      },
      async logout(){
        await this.$store.dispatch('user/logout')
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)

      },
      
      // 手动删除标签
      delTag(index) {
        // 若只有一个标签 不删除
        if (this.tagList.length == 1) 
        {
          return
        } 
        else if (this.tagList[index].path === this.$route.path)
        {
          // 若删除当前页面对应的标签 则跳转到前一个或后一个标签
          if (index === 0) {
            this.$router.push(this.tagList[index + 1].path)
          } else {
            this.$router.push(this.tagList[index - 1].path)
          }
        }
        this.tagList.splice(index, 1)
        this.nameList = computed(() =>
          this.tagList.map((item) => item.name)
        );
      },

      // 选择标签样式
      isActive(path) {
        var result = ''
        if (path !== this.$route.path) {
          result = 'info'
        }
        return result
      }
    }
  };
</script>

<style lang="less" scoped>
  .home_container {
    height: 100%;
    width: 100%;
  }

  .home_header {
    height: 70px !important;
    padding-left: 5px;
    background-color: #373d41;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 40px;
    color: #fff;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);

    img {
      height: 70px;
      object-fit: contain;
    }
  }

  .powerOff button {
    border: none;
    background-color: transparent;
    color: #fff;
    font-size: 16px;
    padding-left: 5px;
  }

  .powerOff i {
    font-size: 16px;
    cursor: pointer;
  }

  .el-aside {
    height: calc(100vh - 70px);
    display: flex;
    flex-direction: column;
    background-color: #333744;
    overflow: hidden;
  }

  .scaleButton {
    height: 20px;
    line-height: 20px;
    vertical-align: middle;
    background-color: #333744;
    color: #ffffffa6;
    border: none;
    cursor: pointer;
    border-top: 1px solid rgb(118, 118, 118);
  }

  .scaleButton:hover {
    color: #ffffff;
  }

  .el-menu {
    flex: 1;
    border: none;
    overflow: hidden;
  }

  /deep/ .el-menu--inline {
    background-color: #232734 !important;

    .el-menu-item {
      background-color: #232734 !important;
    }

    .el-menu-item:hover {
      background-color: rgb(25, 28, 38) !important;
    }

    .is-active {
      color: #2cb2e7 !important;
    }
  }

  .el-menu-item,
  .el-submenu /deep/ .el-submenu__title {
    box-sizing: border-box;
    margin: 5px 0 0 0;
    font-size: 16px;
  }

  .el-submenu .el-menu-item {
    font-size: 14px;
  }

  .is-active {
    color: #2cb2e7 !important;
  }

  .navigation_header {
    display: flex;
    align-items: center;
    height: 30px !important;
    border-bottom: 1px solid #dbe2ea;
    background-color: #fff;
    box-shadow: 0px 5px 10px 0px rgb(0 0 0 / 10%);
    z-index: 999;
    padding: 0 5px;

    .el-tag {
      display: flex;
      height: 25px;
      width: 120px;
      margin-right: 5px;
      line-height: 25px;
      text-align: center;

      a {
        flex-grow: 1;
        text-decoration: none;
        color: inherit;
      }

      /deep/ i {
        top: 50%;
        transform: translate(0, -50%);
      }
    }
  }

  .el-main {
    height: calc(100vh - 100px);
    padding: 10px;
    background-color: #f0f0f0;
  }
</style>
